<template>
  <v-tab-item :id="'2'" style="width: 100%; height: 500px">
    <v-card>
      <v-flex xs12 sm12 md12 pa-2>
        <v-form ref="formRate" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3>
              <v-select
                label="Oda"
                :items="rooms"
                v-model="roomType"
                item-text="type"
                item-value="type"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select
                :items="mealPlans"
                item-text="FilterName"
                item-value="FilterId"
                v-model="rate.RatePlans.RatePlan[0].Description.Name"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                label="Öğün Tipi"
              ></v-select>
            </v-flex>
            
            <v-flex xs12 sm6 md2>
              <v-checkbox
                label="İade Edilebilir"
                v-model="rate.RatePlans.RatePlan[0].NonRefundable"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                label="Yetişkin Adet"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                v-model="rate.RatePlans.RatePlan[0].PersonCount"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md1>
              <v-btn block color="primary" @click="saveRate()" dark
                >Konsept Ekle</v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>

      <v-flex xs12 sm12 md12 pa-2>
        <v-flex xs12 sm12 md12 pa-2>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            class="elevation-1"
            item-key="id"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.ratePlanType }}</td>
              <td class="text-xs-left">
                {{ GetRefundType(props.item.refundable) }}
              </td>
              <td class="text-xs-left">{{ props.item.personCount }}</td>
              <td class="text-xs-left">
                <v-btn
                  flat
                  icon
                  small
                  @click="editRate(props.item)"
                  color="primary"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  small
                  @click="deleteRate(props.item.rateId)"
                  color="primary"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-flex>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="dialogRateEdit" persistent max-width="900px">
        <v-card>
          <v-card-title>
            <span class="headline">Konsept Düzenle</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-form ref="formRateUpdate" v-model="valid" lazy-validation>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        label="Oda"
                        :items="rooms"
                        v-model="updateRate.roomType"
                        item-text="type"
                        item-value="type"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        :items="mealPlans"
                        item-text="FilterName"
                        item-value="FilterId"
                        v-model="updateRate.Name"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        label="Konsept Tip"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-checkbox
                        label="İade Edilebilir"
                        v-model="updateRate.Refundable"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm6 md2>
                      <v-text-field
                        label="Yetişkin Adet"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                        v-model="updateRate.PersonCount"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="dialogRateEdit = false"
              >Vazgeç</v-btn
            >
            <v-btn color="blue darken-1" flat @click="updateRates()"
              >Güncelle</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-tab-item>
</template>


<script>
import auth from "@/api/auth.js";

export default {
  props: {
    isChoosen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mealPlans: [
        {
          FilterId: 0,
          FilterName: "(None)",
        },
        {
          FilterId: 1,
          FilterName: "All inclusive",
        },
        {
          FilterId: 3,
          FilterName: "Bed & breakfast",
        },
        {
          FilterId: 10,
          FilterName: "Full board",
        },
        {
          FilterId: 12,
          FilterName: "Half board",
        },
        {
          FilterId: 24,
          FilterName: "Ultra All Inclusive",
        },
        {
          FilterId: 25,
          FilterName: "No plan",
        },
        {
          FilterId: 125,
          FilterName: "Only Room",
        },
      ],
      updateRate: {
        HotelCode: 0,
        roomType: null,
        Name: null,
        Refundable: false,
        PersonCount: 0,
        RateId:0,
      },
      dialogRateEdit: false,
      valid: true,
      items: [],
      roomType: null,
      headers: [
        {
          text: "Konsept Tipi",
        },
        {
          text: "İade",
        },
        {
          text: "Kişi",
        },
        {
          text: "İşlem",
        },
      ],
      rooms: [],
      rate: {
        NextRequest: true,
        RatePlans: {
          HotelCode: 0,
          RatePlan: [
            {
              Description: {
                Name: null,
              },
              NonRefundable: false,
              PersonCount: 0,
              RatePlanID: null,
              RatePlanNotifType: "Active",
            },
          ],
        },
      },
    };
  },
  watch: {
    isChoosen: function () {
      if (this.isChoosen) {
        this.getRateList();
        this.getRoomList();
      }
    },
  },
  methods: {
    updateRates() {
      if (this.$refs.formRateUpdate.validate()) {
        this.updateRate.HotelCode = this.$route.query.kod;
        var mealPlan = this.mealPlans.find((x) => x.FilterId == this.updateRate.Name);
        this.updateRate.Name =
          this.updateRate.roomType +
          " - " +
          mealPlan.FilterName;
        if(this.updateRate.Refundable == false){
          this.updateRate.Name += " - NR "; 
        }


        this.updateRate.Name += " - " + this.updateRate.PersonCount + " Person";
        var params = this.updateRate;

        this.$http
          .post(
            auth.HOTELRUNNER_API_URL + "api/v1/UpdateRate",
            params,
            {
              headers: {
                Authorization:
                  "Basic " +
                  window.btoa(
                    auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                  ),
              },
            }
          )
          .then(
            (response) => {
              this.text1 = response.body.Message;
              this.snackbar = true;
              this.getRateList();
              this.dialogRateEdit = false;
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
                this.dialogRateEdit = false;
              } else {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
                this.dialogRateEdit = false;
              }
            }
          );
      }
    },
    editRate(rate) {
      let roomName = rate.ratePlanType.split("-");
      var mealPlan = this.mealPlans.find(x=> x.FilterName == roomName[1].trim());
      this.updateRate.RateId = rate.rateId;
      this.updateRate.roomType = roomName[0].trim();
      this.updateRate.Name = mealPlan.FilterId;
      this.updateRate.Refundable = rate.refundable;
      this.updateRate.PersonCount = rate.personCount;
      this.dialogRateEdit = true;
    },
    getRoomList() {
      var params = {
        OtelId: this.$route.query.kod,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RoomList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.rooms = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 =
                "Service Unavailable-OTA_HotelDescriptiveContentNotif";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 =
                "Service Unavailable-OTA_HotelDescriptiveContentNotif";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    GetRefundType(val) {
      return val == true ? "Edilebilir" : "Edilemez";
    },
    deleteRate(rateId) {
      var params = {
        RateId: rateId,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/DeleteRate", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            if (response.body.status) {
              this.getRateList();
            } else {
              this.text1 = response.body.message;
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-OzellikList";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    getRateList() {
      var params = {
        OtelId: this.$route.query.kod,
      };

      this.$http
        .post(auth.HOTELRUNNER_API_URL + "api/v1/RateList", params, {
          headers: {
            Authorization:
              "Basic " +
              window.btoa(
                auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
              ),
          },
        })
        .then(
          (response) => {
            this.items = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 =
                "Service Unavailable-OTA_HotelDescriptiveContentNotif";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 =
                "Service Unavailable-OTA_HotelDescriptiveContentNotif";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    },
    saveRate() {
      if (this.$refs.formRate.validate()) {
        this.rate.RatePlans.HotelCode = this.$route.query.kod;
        var params = this.rate;
        var mealPlan = this.mealPlans.find((x) => x.FilterId == this.rate.RatePlans.RatePlan[0].Description.Name);
        this.rate.RatePlans.RatePlan[0].Description.Name =
          this.roomType +
          " - " +
          mealPlan.FilterName;
        if(this.rate.RatePlans.RatePlan[0].NonRefundable == false){
          this.rate.RatePlans.RatePlan[0].Description.Name += " - NR "; 
        }


        this.rate.RatePlans.RatePlan[0].Description.Name += " - " + this.rate.RatePlans.RatePlan[0].PersonCount + " Person";
  

        this.$http
          .post(
            auth.HOTELRUNNER_API_URL + "api/hotels/ota/OTA_HotelRatePlanNotif",
            params,
            {
              headers: {
                Authorization:
                  "Basic " +
                  window.btoa(
                    auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS
                  ),
              },
            }
          )
          .then(
            (response) => {
              this.text1 = response.body.Message;
              this.snackbar = true;
              this.rate.RatePlans.RatePlan[0].Description.Name = null;
              this.rate.RatePlans.RatePlan[0].NonRefundable = false;
              this.rate.RatePlans.RatePlan[0].PersonCount = 0;
              this.getRateList();
              //this.rooms = [];
            },
            (response) => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-OTA_HotelRatePlanNotif";
                this.snackbar = true;
              }
            }
          );
      }
    },
  },
};
</script>
